"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _get = _interopRequireDefault(require("lodash/get"));
var _find = _interopRequireDefault(require("lodash/find"));
var _decorators = require("../../../decorators");
var _reactIntl = require("react-intl");
var _StepNumber = require("../../StepNumber");
var _Button = _interopRequireDefault(require("../../StepCheckToolbar/Escalation/Button"));
var _Button2 = _interopRequireDefault(require("../../StepCheckToolbar/Dispatch/Button"));
var _checklistUtils = require("../../../utils/checklist-utils");
var _Toolbar = _interopRequireDefault(require("./Toolbar"));
var _styles = require("./styles");
var _dec, _class, _class2, _descriptor, _StepCardComponent;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var StepCardComponent = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (0, _mobxReact.observer)(_class = (0, _decorators.styleable)(_class = (_class2 = (_StepCardComponent = /*#__PURE__*/function (_Component) {
  function StepCardComponent(props) {
    var _this;
    _classCallCheck(this, StepCardComponent);
    _this = _callSuper(this, StepCardComponent, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var _this$props = _this.props,
        isCheck = _this$props.isCheck,
        isCurrent = _this$props.isCurrent,
        isCMS = _this$props.isCMS;
      if (isCheck && !isCMS) {
        var _this$props$store = _this.props.store,
          instructionId = _this$props$store.instructionPage.currentInstruction.id,
          setChecklist = _this$props$store.checklist.setChecklist;
        var checklist = (0, _checklistUtils.getChecklistFromLocalStorage)(instructionId);
        setChecklist(checklist);
      } else {
        isCurrent && _this.popupMandatoryNote();
      }
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (!prevProps.isCurrent && _this.props.isCurrent) {
        _this.popupMandatoryNote();
      }
    });
    _initializerDefineProperty(_this, "popupMandatoryNote", _descriptor, _this);
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(StepCardComponent, _Component);
  return _createClass(StepCardComponent, [{
    key: "render",
    value: function render() {
      var _instructionPage$curr, _step$media;
      var _this$props2 = this.props,
        autoplayVideo = _this$props2.autoplayVideo,
        content = _this$props2.content,
        getToolbarButtonStyle = _this$props2.getToolbarButtonStyle,
        hintContent = _this$props2.hintContent,
        hintImageSizes = _this$props2.hintImageSizes,
        imageSizes = _this$props2.imageSizes,
        isCheck = _this$props2.isCheck,
        media = _this$props2.media,
        onToggleHint = _this$props2.onToggleHint,
        orientation = _this$props2.orientation,
        selectedHintType = _this$props2.selectedHintType,
        shouldAllToolbarItemsBeEnabled = _this$props2.shouldAllToolbarItemsBeEnabled,
        shouldShowSpinnerWhileLoading = _this$props2.shouldShowSpinnerWhileLoading,
        step = _this$props2.step,
        _this$props2$number = _this$props2.number,
        number = _this$props2$number === void 0 ? step.number || step.position + 1 : _this$props2$number,
        noteContentKey = _this$props2.noteContentKey,
        isCMS = _this$props2.isCMS,
        store = _this$props2.store,
        stepIndex = _this$props2.stepIndex,
        footer = _this$props2.footer;
      var _store$platform = store.platform,
        hasChecklistEscalation = _store$platform.hasChecklistEscalation,
        hasDispatchSite = _store$platform.hasDispatchSite,
        hasDispatchEnabled = _store$platform.hasDispatchEnabled,
        dispatch = _store$platform.developmentFeatureFlags.dispatch,
        instructionPage = store.instructionPage;
      var imageUrl = step.imageUrl,
        instructionHtml = step.instructionHtml,
        notes = step.notes;
      var hasAlertRecipients = instructionPage === null || instructionPage === void 0 || (_instructionPage$curr = instructionPage.currentInstruction) === null || _instructionPage$curr === void 0 ? void 0 : _instructionPage$curr.hasAlertRecipients;
      var metadata = step.metadata ? step.metadata : (_step$media = step.media) !== null && _step$media !== void 0 && _step$media.metadata ? step.media.metadata : {};
      var hasDispatchButton = dispatch && hasDispatchSite && hasDispatchEnabled && isCheck && !isCMS;
      var hasReportButton = !hasDispatchButton && (hasChecklistEscalation || hasAlertRecipients) && isCheck && !isCMS;
      return /*#__PURE__*/_react["default"].createElement(_styles.StepSlide, {
        "data-cy": "step-card",
        hasReportButton: hasReportButton
      }, hasReportButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        stepIndex: stepIndex
      }), hasDispatchButton && /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
        stepIndex: stepIndex
      }), /*#__PURE__*/_react["default"].createElement(_styles.StepCard, {
        orientation: orientation
      }, /*#__PURE__*/_react["default"].createElement(_styles.Left, {
        orientation: orientation
      }, content || /*#__PURE__*/_react["default"].createElement(_styles.StepContent, {
        dangerouslySetInnerHTML: {
          __html: instructionHtml
        },
        isCompact: false,
        isResponsive: true,
        isScrollable: true,
        footer: footer
      }), !isCheck && /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
        getToolbarButtonStyle: getToolbarButtonStyle,
        hintContent: hintContent,
        imageSizes: hintImageSizes,
        isCheck: isCheck,
        onToggle: onToggleHint,
        selectedType: selectedHintType,
        shouldAllToolbarItemsBeEnabled: shouldAllToolbarItemsBeEnabled,
        shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
        notes: notes,
        noteContentKey: noteContentKey
      })), /*#__PURE__*/_react["default"].createElement(_styles.Right, {
        orientation: orientation
      }, media || /*#__PURE__*/_react["default"].createElement(_styles.StepMedia, {
        autoplayVideo: autoplayVideo,
        mediaUrl: imageUrl,
        imageSizes: imageSizes,
        metadata: metadata,
        shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading
      }))), /*#__PURE__*/_react["default"].createElement(_StepNumber.StepNumberDesktop, {
        number: number
      }));
    }
  }]);
}(_react.Component), _defineProperty(_StepCardComponent, "defaultProps", {
  isCheck: true,
  shouldShowSpinnerWhileLoading: false,
  step: Object.freeze({}),
  noteContentKey: 'contentHtml'
}), _defineProperty(_StepCardComponent, "propTypes", {
  autoplayVideo: _propTypes["default"].bool,
  content: _propTypes["default"].element,
  getToolbarButtonStyle: _propTypes["default"].func,
  hintContent: _propTypes["default"].element,
  hintImageSizes: _propTypes["default"].string,
  imageSizes: _propTypes["default"].string,
  isCheck: _propTypes["default"].bool,
  media: _propTypes["default"].element,
  number: _propTypes["default"].number,
  onToggleHint: _propTypes["default"].func,
  orientation: _propTypes["default"].oneOf(['landscape', 'portrait']).isRequired,
  selectedHintType: _propTypes["default"].string,
  shouldAllToolbarItemsBeEnabled: _propTypes["default"].bool,
  shouldShowSpinnerWhileLoading: _propTypes["default"].bool,
  step: _propTypes["default"].object,
  noteContentKey: _propTypes["default"].oneOf(['content', 'contentHtml']).isRequired,
  checklistTemplate: _propTypes["default"].object
}), _StepCardComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "popupMandatoryNote", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function () {
      var mandatoryNoteId = (0, _get["default"])((0, _find["default"])(_this2.props.step.notes, {
        mandatory: true
      }), 'iconId');
      mandatoryNoteId && _this2.props.onToggleHint({
        type: mandatoryNoteId
      });
    };
  }
})), _class2)) || _class) || _class) || _class);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(StepCardComponent);
//# sourceMappingURL=index.js.map